import { TranslationFunction } from 'i18next'
import React, { SFC } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'

import { SignalRConnection } from 'modules/signal-r'

import { i18nKeys } from '../app.i18n'
import { links } from '../app.links'
import { User } from '../auth'
import { ACTIVE_CLASS_NAME, NAVLINK_CLASS_NAME, renderNotificationBadge } from '../shared'

type Props = OwnProps & RouteComponentProps<{}>
type OwnProps = {
  user: User
  t: TranslationFunction
}
export const TeamNav: SFC<Props> = ({ match, user, t }) => (
  <>
    <div className="sidebar__title">{t(i18nKeys.frontFace.activityBar.team)}</div>
    {user.hasSubordinates && (
      <NavLink
        className={NAVLINK_CLASS_NAME}
        to={links.frontFace.team.my(match.path)}
        activeClassName={ACTIVE_CLASS_NAME}
      >
        <SignalRConnection operation="MyTeamNotificationCount" initParams={user.personId}>
          {(data) => (
            <>
              {t(i18nKeys.frontFace.teams.label)}
              {renderNotificationBadge(data)}
            </>
          )}
        </SignalRConnection>
      </NavLink>
    )}

    <NavLink
      className={NAVLINK_CLASS_NAME}
      to={links.frontFace.team.teamGoals.home(match.path)}
      activeClassName={ACTIVE_CLASS_NAME}
    >
      <SignalRConnection operation="TeamGoalsNotificationCount" initParams={user.personId}>
        {(data) => (
          <>
            {t(i18nKeys.frontFace.goals.teamGoals)}
            {renderNotificationBadge(data)}
          </>
        )}
      </SignalRConnection>
    </NavLink>

    <NavLink
      className={NAVLINK_CLASS_NAME}
      to={links.frontFace.team.teamReviews.home(match.path)}
      activeClassName={ACTIVE_CLASS_NAME}
    >
      <SignalRConnection operation="TeamReviewNotificationCount" initParams={user.personId}>
        {(data) => (
          <>
            {t(i18nKeys.frontFace.teamReviews.label)}
            {renderNotificationBadge(data)}
          </>
        )}
      </SignalRConnection>
    </NavLink>

    {user.hasFormerTeam && (
      <NavLink className={NAVLINK_CLASS_NAME} to={links.frontFace.team.myFormer()} activeClassName={ACTIVE_CLASS_NAME}>
        {t(i18nKeys.frontFace.activityBar.myFormerTeam)}
      </NavLink>
    )}
  </>
)



// WEBPACK FOOTER //
// ./src/app/sidebar-navigation/team.tsx